<template>
    <g>
        <g transform="scale(0.50)">
            <text transform="matrix(1 0 0 1 -20 -100)" font-size="36px">다이오드</text>
            <linearGradient id="무제_그라디언트_127" x1="260.75" y1="275.45" x2="260.75" y2="282.8"
                gradientTransform="translate(40.84 145.9)" gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#fff" />
                <stop offset="0" stop-color="#ededed" />
                <stop offset="0" stop-color="#cecece" />
                <stop offset="0" stop-color="#b2b2b2" />
                <stop offset="0" stop-color="#9c9c9c" />
                <stop offset="0" stop-color="#8b8b8b" />
                <stop offset="0" stop-color="gray" />
                <stop offset="0" stop-color="#797979" />
                <stop offset="0" stop-color="#777" />
                <stop offset="0.14" stop-color="#868687" />
                <stop offset="0.42" stop-color="#a0a0a1" />
                <stop offset="0.57" stop-color="#9d9d9e" />
                <stop offset="0.69" stop-color="#949494" />
                <stop offset="0.79" stop-color="#848484" />
                <stop offset="0.89" stop-color="#6d6d6e" />
                <stop offset="0.98" stop-color="#505051" />
                <stop offset="1" stop-color="#474747" />
            </linearGradient>
            <linearGradient id="무제_그라디언트_127_2" x1="347.28" y1="275.37" x2="347.28" y2="282.72"
                gradientTransform="translate(-45.77 59.46)" xlink:href="#무제_그라디언트_127" />
            <g transform="translate(120 -90) rotate(90)">
                <rect class="cls-2" x="271.93" y="421.35" width="59.31" height="7.35" rx="2.36"
                transform="translate(-407.12 417.77) rotate(-90)" />
                <rect class="cls-2" x="271.85" y="334.83" width="59.31" height="7.35" rx="2.36"
                    transform="translate(-320.68 331.17) rotate(-90)" />
                <rect class="cls-3" y="37.13" width="35.67" height="75.44" rx="10.46" />
                <rect class="cls-4" y="83.89" width="35.67" height="9.95" />
                <circle :id="pincode + 'PS'" class="pin-cover terminal snap res_plus" @click="onClick(`${pincode}PS`)" cx="18" cy="0" r="6" />
                <circle :id="pincode + 'MS'" class="pin-cover terminal snap res_minus" @click="onClick(`${pincode}MS`)" cx="18" cy="150" r="6" />
            </g>
          </g>
    </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  name: 'Diode',
  data () {
    return {
      code: ''
    }
  },
  mounted () {
    this.setPindata(this.data)
    this.code = this.namecode
  },
  methods: {
    onClick (pin) {
      console.log('where is data?: ' + JSON.stringify(this.data))
      console.log(this.pincode)
      console.log(pin)
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    }
  }

}
</script>

<style lang="scss" scoped>
.selected {
  .cls-2, .cls-3 {
      stroke-width: 4px;
      stroke: #ff6f61;
  }
}
/* .res_plus, .res_minus {
  visibility: hidden;
} */
.res_plus:hover,
.res_minus:hover {
  visibility: visible;
  cursor: pointer;
  fill: #e60012;
}
.cls-1 {
  fill: url(#무제_그라디언트_127);
}
.cls-2 {
  fill: url(#무제_그라디언트_127_2);
}
.cls-3 {
  fill: #323333;
}
.cls-4 {
  fill: #68747d;
}
</style>
